import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';

const rocheTabNavButtonCss = "roche-tab-nav-button{font-family:\"roche-sans\";font-style:normal;font-weight:200;color:var(--color-text--primary);font-size:var(--body--font-size--small-up);line-height:1.8125rem;font-weight:400;display:inline;position:relative;border:1px solid #dbd6d1;padding:0.34375rem 1rem;color:#544f4f;white-space:nowrap}@media (min-width: 64rem){roche-tab-nav-button{font-size:var(--body--font-size--xlarge-up);line-height:2rem}}@media (min-width: 90rem){roche-tab-nav-button{font-size:1.125rem;line-height:1.8125rem}}roche-tab-nav-button:focus,roche-tab-nav-button:focus-visible{outline:var(--color-interactive--focus) dashed 2px;outline-offset:unset}roche-tab-nav-button:focus:not(:focus-visible){outline:none}roche-tab-nav-button:hover,roche-tab-nav-button[active]{background-color:var(--color-interactive--primary-hover);border-color:var(--color-interactive--primary-hover);color:#fff;transition:background-color 200ms ease, border-color 200ms ease, color 200ms ease;text-decoration:none}roche-tab-nav-button:hover:not([active]){background-color:#eae8e5;border-color:#706b69;color:#544f4f;cursor:pointer}";
const RocheTabNavButtonStyle0 = rocheTabNavButtonCss;

const RocheTabNavButton$1 = /*@__PURE__*/ proxyCustomElement(class RocheTabNavButton extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.active = undefined;
    }
    render() {
        return (h("slot", { key: 'cd41f3ac45d5c65cd16e4bf46406585ed4186c2e' }));
    }
    static get style() { return RocheTabNavButtonStyle0; }
}, [4, "roche-tab-nav-button", {
        "active": [4]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-tab-nav-button"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-tab-nav-button":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheTabNavButton$1);
            }
            break;
    } });
}

const RocheTabNavButton = RocheTabNavButton$1;
const defineCustomElement = defineCustomElement$1;

export { RocheTabNavButton, defineCustomElement };

//# sourceMappingURL=roche-tab-nav-button.js.map